import TopHeaderSwiper from "../../global/swiper/TopHeaderSwiper";
import ArrowIcon from "../../icons/ArrowIcon";
import DashboardAvatarIcon from "../../icons/dashboard-avatar";
import PaySecurelyIcon from "../../icons/PaySecurelyIcon";
import FastDeliveryIcon from "../../icons/FastDeliveryIcon";
import GpsIcon from "../../icons/GpsIcon";
import GridEditIcon from "../../icons/GridEditIcon";
import LocaleSwitcher from "../../global/buttons/LocaleSwitcher";
import ContactUsIcon from "../../icons/ContactUsIcon";
import { useGlobalData } from "@/context/global";
import MenuCategoryTree from "./MenuCategoryTree";
import { useTranslation } from "next-i18next";
import { useSession } from "next-auth/react";
import { useRouter } from "next/router";
import PhoneIcon from "@/components/icons/PhoneIcon";
import WhatsappIcon from "@/components/icons/WhatsappIcon";
import EmailIcon from "@/components/icons/EmailIcon";
import Link from "next/link";

const SideMenu = ({ Context }) => {
  const {
    appData: { menuTreeData },
  } = useGlobalData();
  const { t } = useTranslation("common");
  const { data: session } = useSession();
  const { locale, push } = useRouter();
  return (
    <section className="fixed top-0 left-0 w-screen h-screen z-modal">
      <div className="py-3 text-white bg-primary">
        <TopHeaderSwiper />
      </div>
      <div className="flex">
        <div className="overflow-y-auto py-4 w-80 min-h-screen max-h-screen bg-white sm:w-96">
          <div
            onClick={() => {
              if (!session?.user) {
                Context?.dispatch({ type: "auth" });
              } else {
                Context.dispatch({ type: "sidemenu" });
                push("/user");
              }
            }}
            className="flex justify-between items-center px-5 pb-3 border-b cursor-pointer"
          >
            <div className="flex gap-3 items-center">
              <DashboardAvatarIcon className={`size-5`} />
              {!session?.user && (
                <span className="cursor-pointer max-sm:text-sm">
                  {t("Login / Register")}
                </span>
              )}
              {session?.user && (
                <div className="flex flex-col gap-0.25">
                  <span className="text-primary-800">{t("Welcome")}</span>
                  <span className="font-bold capitalize">
                    {session?.user?.firstname} {session?.user?.lastname}
                  </span>
                </div>
              )}
            </div>
            <ArrowIcon
              className={`size-4 ${locale === "ar" && "rotate-180"}`}
            />
          </div>

          <MenuCategoryTree menuTreeData={menuTreeData} />

          <div className="pt-4 border-b max-sm:text-sm">
            <div
              onClick={() => Context?.dispatch({ type: "trackOrder" })}
              className="flex justify-between items-center px-5 pb-5 cursor-pointer"
            >
              <div className="flex gap-4 items-center">
                <GpsIcon className="size-4" />
                <span>{t("Track Order")}</span>
              </div>
            </div>
            <div className="flex justify-between items-center px-5 pb-5">
              <div className="flex gap-4 items-center">
                <PaySecurelyIcon className="size-4" />
                <span>{t("Pay Securely")}</span>
              </div>
            </div>
            <div className="flex justify-between items-center px-5 pb-5">
              <div className="flex gap-4 items-center">
                <FastDeliveryIcon className="size-4" />
                <span>{t("Fast Delivery")}</span>
              </div>
            </div>
            <div className="flex justify-between items-center px-5 pb-5">
              <div className="flex gap-4 items-center">
                <GridEditIcon className="size-4" />
                <div className="flex flex-col gap-0.5">
                  <span>{t("Change Language")}</span>
                  <span
                    className="text-xs sm:text-sm text-zinc-500"
                    onClick={() => Context.dispatch({ type: "sidemenu" })}
                  >
                    <LocaleSwitcher isResponsive />
                  </span>
                </div>
              </div>
            </div>
            <div className="px-5 pb-5">
              <div className="flex gap-4 items-center">
                <ContactUsIcon className="size-4" />
                <span>{t("Need Help")}</span>
              </div>
              {/* <p className="mt-2 mb-3 text-zinc-500 max-sm:text-xs">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. sed
                similique vero excepturi cumque consequuntur autem quibusdam
                repellat porro adipisci.
              </p> */}
              <ul className="flex items-center gap-3 text-[11px]">
                <li className="border rounded-[3px] p-2">
                  <Link
                    href={"tel:8002440277"}
                    className="flex gap-2 items-center"
                  >
                    <PhoneIcon />
                    <span>{t("Call us")}</span>
                  </Link>
                </li>
                <li className="border rounded-[3px] p-2">
                  <Link
                    href={"https://wa.me/9668002440277"}
                    className="flex gap-2 items-center"
                  >
                    <WhatsappIcon />
                    <span>{t("Whatsapp")}</span>
                  </Link>
                </li>
                <li className="border rounded-[3px] p-2">
                  <Link
                    href={"mailto:e-customercare@abdulwahed.com"}
                    className="flex gap-2 items-center"
                  >
                    <EmailIcon />
                    <span>{t("Email")}</span>
                  </Link>
                </li>
              </ul>
            </div>
            <Link prefetch={false} href={"/privacy-policy"} onClick={() => Context.dispatch({ type: "sidemenu" })} className="flex justify-between items-center px-5 pb-5">
              <div className="flex gap-4 items-center">
                <span >{t("Privacy Policy")}</span>
              </div>
            </Link>
            <Link prefetch={false} href={"/terms-and-conditions"} onClick={() => Context.dispatch({ type: "sidemenu" })} className="flex justify-between items-center px-5 pb-5">
              <div className="flex gap-4 items-center">
                <span >{t("Terms & Conditions")}</span>
              </div>
            </Link>
            <Link prefetch={false} href={"/faq"} onClick={() => Context.dispatch({ type: "sidemenu" })} className="flex justify-between items-center px-5 pb-14 cursor-pointer">
              <span>{t("FAQ")}</span>
            </Link>
          </div>
        </div>
        <div
          className="flex-1 h-screen bg-black bg-opacity-80"
          onClick={() => Context?.dispatch({ type: "sidemenu" })}
        ></div>
      </div>
    </section>
  );
};

export default SideMenu;
